'use client';

import {
  GlassCard,
  V4CtaButton,
  V4GhostButton,
} from '@/components/landing/v4-shared';
import { MagneticCta } from '@/components/marketing/MagneticCta';
import { trackAeoPrimaryCtaClick } from '@/lib/analytics/enhanced-events';
import { type AeoCtaLocation, type AeoPageFamily } from '@/lib/analytics/enhanced-events';

export function FinalCtaSection({
  heading,
  body,
  ctaLabel,
  ctaHref,
  ctaSecondaryLabel,
  ctaSecondaryHref,
  reassurance,
  analyticsPageFamily,
  analyticsCtaLocation,
}: {
  heading: string;
  body: string;
  ctaLabel: string;
  ctaHref: string;
  ctaSecondaryLabel?: string;
  ctaSecondaryHref?: string;
  reassurance?: string;
  analyticsPageFamily?: AeoPageFamily;
  analyticsCtaLocation?: AeoCtaLocation;
}) {
  return (
    <section
      aria-labelledby="final-cta-heading"
      className="relative"
      style={{ paddingTop: 128, paddingBottom: 160, overflow: 'hidden' }}
    >
      {/* Ambient glow */}
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          bottom: 0,
          left: '50%',
          transform: 'translateX(-50%)',
          width: '100%',
          height: 480,
          background:
            'radial-gradient(ellipse 1000px 380px at 50% 100%, rgba(34,211,238,0.18), transparent 65%)',
          pointerEvents: 'none',
        }}
      />
      <div className="max-w-[960px] mx-auto px-6 relative">
        <GlassCard accent="cyan" padding={36} radius={24}>
          <div style={{ textAlign: 'center', maxWidth: 580, margin: '0 auto' }}>
            <h2
              id="final-cta-heading"
              style={{
                fontFamily: 'var(--font-geist-sans)',
                fontSize: 'clamp(28px, 3.6vw, 44px)',
                fontWeight: 500,
                color: 'var(--paper)',
                letterSpacing: '-0.02em',
                lineHeight: 1.1,
                margin: '0 0 24px',
              }}
            >
              {heading}
            </h2>
            <p
              style={{
                fontSize: 16,
                lineHeight: 1.55,
                color: 'var(--dim)',
                margin: '0 0 32px',
              }}
            >
              {body}
            </p>
            <MagneticCta>
              <V4CtaButton
                href={ctaHref}
                size="lg"
                onClick={
                  analyticsPageFamily && analyticsCtaLocation
                    ? () =>
                        trackAeoPrimaryCtaClick({
                          page_family: analyticsPageFamily,
                          cta_location: analyticsCtaLocation,
                        })
                    : undefined
                }
              >
                {ctaLabel}
              </V4CtaButton>
            </MagneticCta>
            {ctaSecondaryLabel && ctaSecondaryHref && (
              <p style={{ marginTop: 12 }}>
                <V4GhostButton variant="paper" href={ctaSecondaryHref} size="md">
                  {ctaSecondaryLabel}
                </V4GhostButton>
              </p>
            )}
            {reassurance && (
              <p style={{ fontFamily: 'var(--font-geist-mono)', fontSize: 12, letterSpacing: '0.04em', color: 'var(--dim)', marginTop: 16 }}>
                {reassurance}
              </p>
            )}
          </div>
        </GlassCard>
      </div>
    </section>
  );
}
